import React from "react";

const TagLine = () => {
  return (
    <p className="max-w-xl text-sm md:text-xl font-bold z-0 pb-5">
      <span className="text-[#7000ff] font-semibold">Innovating</span> Web
      Experience
    </p>
  );
};

export default TagLine;
